<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- AKTIONEN -->

      <container-headline
        class="col-xl-12"
        :headline="$t('global.points')"
        :col="3"
      >
        <div class="row">
          <div class="ml-4 mr-2">
            <button
              class="btn btn-success"
              @click="notenSpeichern()"
              :disabled="!editable"
            >
              {{ $t('global.saveevaluations') }}
            </button>
          </div>
        </div>
      </container-headline>

      <!-- INHALT -->

      <div class="row col-xl-12">
        <div class="col-xl-12 block belegliste br-t-l-0">
          <div>
            <b-table
              class="minh-200-px"
              ref="notenerfassungPunkteTable"
              tbody-tr-class="item"
              :items="notenliste"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :busy="isBusy"
              show-empty
              sort-icon-left
              small
              thead-tr-class="pointer"
            >
              <template #thead-top>
                <b-tr>
                  <b-th colspan="5">
                    <span class="sr-only">{{ $t('global.nameandid') }}</span>
                  </b-th>
                  <b-th
                    class="text-center border-left"
                    colspan="2"
                    v-if="pruefungCount > 0"
                  >
                    {{ pruefungLabel[0] }}
                  </b-th>
                  <b-th
                    class="text-center border-left"
                    colspan="2"
                    v-if="pruefungCount > 1"
                  >
                    {{ pruefungLabel[1] }}
                  </b-th>
                  <b-th
                    class="text-center border-left"
                    colspan="2"
                    v-if="pruefungCount > 2"
                  >
                    {{ pruefungLabel[2] }}
                  </b-th>
                  <b-th
                    class="text-center border-left"
                    colspan="2"
                    v-if="pruefungCount > 3"
                  >
                    {{ pruefungLabel[3] }}
                  </b-th>
                  <b-th
                    class="text-center border-left"
                    colspan="2"
                    v-if="pruefungCount > 4"
                  >
                    {{ pruefungLabel[4] }}
                  </b-th>
                </b-tr>
              </template>

              <template v-slot:cell(korrektur)="row">
                <b-form-input
                  v-model="row.item.note.korrektur"
                  @input="checkKorrektur(row.index)"
                  :readonly="!editable"
                  :tabindex="1 + row.index"
                  size="sm"
                ></b-form-input>
              </template>

              <template
                v-if="pruefungCount > 0"
                v-slot:cell(gewichtung1)="row"
              >
                {{ row.item.details[0].pruefung.gewichtung }}
              </template>
              <template
                v-if="pruefungCount > 1"
                v-slot:cell(gewichtung2)="row"
              >
                {{ row.item.details[1].pruefung.gewichtung }}
              </template>
              <template
                v-if="pruefungCount > 2"
                v-slot:cell(gewichtung3)="row"
              >
                {{ row.item.details[2].pruefung.gewichtung }}
              </template>
              <template
                v-if="pruefungCount > 3"
                v-slot:cell(gewichtung4)="row"
              >
                {{ row.item.details[3].pruefung.gewichtung }}
              </template>
              <template
                v-if="pruefungCount > 4"
                v-slot:cell(gewichtung5)="row"
              >
                {{ row.item.details[4].pruefung.gewichtung }}
              </template>

              <template v-slot:cell(pruefung1)="row">
                <b-form-input
                  v-if="row.item.details[0]"
                  v-model="row.item.details[0].bewertung.bewertung"
                  :on-change="checkBewertung(1, row.index)"
                  :state="row.item.details[0].invalid"
                  :tabindex="1000 + row.index"
                  :readonly="
                    !row.item.details[0].pruefung.editable || !editable
                  "
                  @blur.native="formatNote(1, row.index)"
                  required
                  size="sm"
                ></b-form-input>
                <b-form-invalid-feedback v-if="row.item.details[0]">
                  {{ $t('global.pointgradenotification') }}
                </b-form-invalid-feedback>
              </template>
              <template v-slot:cell(pruefung2)="row">
                <b-form-input
                  v-if="row.item.details[1]"
                  v-model="row.item.details[1].bewertung.bewertung"
                  :on-change="checkBewertung(2, row.index)"
                  :state="row.item.details[1].invalid"
                  :tabindex="2000 + row.index"
                  :readonly="
                    !row.item.details[1].pruefung.editable || !editable
                  "
                  @blur.native="formatNote(2, row.index)"
                  required
                  size="sm"
                ></b-form-input>
                <b-form-invalid-feedback v-if="row.item.details[1]">
                  {{ $t('global.pointgradenotification') }}
                </b-form-invalid-feedback>
              </template>
              <template v-slot:cell(pruefung3)="row">
                <b-form-input
                  v-if="row.item.details[2]"
                  v-model="row.item.details[2].bewertung.bewertung"
                  :on-change="checkBewertung(3, row.index)"
                  :state="row.item.details[2].invalid"
                  :tabindex="3000 + row.index"
                  :readonly="
                    !row.item.details[2].pruefung.editable || !editable
                  "
                  @blur.native="formatNote(3, row.index)"
                  required
                  size="sm"
                ></b-form-input>
                <b-form-invalid-feedback v-if="row.item.details[2]">
                  {{ $t('global.pointgradenotification') }}
                </b-form-invalid-feedback>
              </template>
              <template v-slot:cell(pruefung4)="row">
                <b-form-input
                  v-if="row.item.details[3]"
                  v-model="row.item.details[3].bewertung.bewertung"
                  :on-change="checkBewertung(4, row.index)"
                  :state="row.item.details[3].invalid"
                  :tabindex="4000 + row.index"
                  :readonly="
                    !row.item.details[3].pruefung.editable || !editable
                  "
                  @blur.native="formatNote(4, row.index)"
                  required
                  size="sm"
                ></b-form-input>
                <b-form-invalid-feedback v-if="row.item.details[3]">
                  {{ $t('global.pointgradenotification') }}
                </b-form-invalid-feedback>
              </template>
              <template v-slot:cell(pruefung5)="row">
                <b-form-input
                  v-if="row.item.details[4]"
                  v-model="row.item.details[4].bewertung.bewertung"
                  :on-change="checkBewertung(5, row.index)"
                  :state="row.item.details[4].invalid"
                  :tabindex="5000 + row.index"
                  :readonly="
                    !row.item.details[4].pruefung.editable || !editable
                  "
                  @blur.native="formatNote(5, row.index)"
                  required
                  size="sm"
                ></b-form-input>
                <b-form-invalid-feedback v-if="row.item.details[4]">
                  {{ $t('global.pointgradenotification') }}
                </b-form-invalid-feedback>
              </template>

              <template v-slot:cell(bewertung)="row">
                <b-form-input
                  v-if="eingabetyp == 'punkte'"
                  v-model="row.item.bewertung"
                  required
                  size="sm"
                  :readonly="!editable"
                ></b-form-input>
              </template>

              <template v-slot:cell(dispensiert)="row">
                <b-button
                  class="mr-2"
                  :variant="
                    row.item.note.dispensiert == true ? 'primary' : 'light'
                  "
                  size="sm"
                  style="width: 150px"
                  :disabled="!editable"
                  :tabindex="100 + row.index"
                  @click="setDispensiert(row.index)"
                >
                  {{
                    row.item.note.dispensiert
                      ? $t('global.dispensed')
                      : $t('global.notdispensed')
                  }}
                </b-button>
              </template>

              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

              <template #empty>
                <div
                  v-if="ladeFehler"
                  class="text-center text-danger my-2"
                >
                  <strong>{{ $t('global.errorwhileloading') }}</strong>
                </div>
                <div
                  v-if="!ladeFehler"
                  class="text-center text-primary my-2"
                >
                  <strong>{{ $t('global.nodataavailable') }}</strong>
                </div>
              </template>

              <template #custom-foot>
                <b-tr>
                  <b-th
                    v-if="pruefungCount > 0"
                    class="text-center"
                    colspan="1"
                  ></b-th>
                  <b-th
                    v-if="pruefungCount > 0"
                    class="text-center"
                    colspan="1"
                  >
                    {{ calcDefClassAverage }}
                  </b-th>
                  <b-th
                    v-if="pruefungCount > 0"
                    class="text-center"
                    colspan="2"
                  ></b-th>
                  <b-th
                    v-if="pruefungCount > 0"
                    class="text-center"
                    colspan="1"
                  >
                    {{ calcProvClassAverage }}
                  </b-th>
                  <b-th
                    v-if="pruefungCount > 0"
                    class="text-left border-left"
                    colspan="1"
                  >
                    {{ calcExamAverage(0) }}
                  </b-th>
                  <b-th
                    v-if="pruefungCount > 0"
                    class="text-right"
                    colspan="1"
                  ></b-th>
                  <b-th
                    v-if="pruefungCount > 1"
                    class="text-left border-left"
                    colspan="1"
                  >
                    {{ calcExamAverage(1) }}
                  </b-th>
                  <b-th
                    v-if="pruefungCount > 1"
                    class="text-right"
                    colspan="1"
                  ></b-th>
                  <b-th
                    v-if="pruefungCount > 2"
                    class="text-left border-left"
                    colspan="1"
                  >
                    {{ calcExamAverage(2) }}
                  </b-th>
                  <b-th
                    v-if="pruefungCount > 2"
                    class="text-right"
                    colspan="1"
                  ></b-th>
                  <b-th
                    v-if="pruefungCount > 3"
                    class="text-left border-left"
                    colspan="1"
                  >
                    {{ calcExamAverage(3) }}
                  </b-th>
                  <b-th
                    v-if="pruefungCount > 3"
                    class="text-right"
                    colspan="1"
                  ></b-th>
                  <b-th
                    v-if="pruefungCount > 4"
                    class="text-left border-left"
                    colspan="1"
                  >
                    {{ calcExamAverage(4) }}
                  </b-th>
                  <b-th
                    v-if="pruefungCount > 4"
                    class="text-right"
                    colspan="1"
                  ></b-th>
                </b-tr>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Api from '@/api/Api'
  import { apiErrorToAlert } from '@/utils/Errorhandler'
  import { BSpinner } from 'bootstrap-vue'
  import ContainerHeadline from '@/components/ContainerHeadline'
  import reiter from '@/mixins/Reiter'
  import App from '@/api/AppApi'

  export default {
    components: {
      ContainerHeadline,
      BSpinner,
    },
    mixins: [reiter],
    props: {
      noteneingabe: {
        type: Object,
        required: true,
      },
      eingabetyp: {
        type: String,
        required: true,
      },
      person: {
        type: String,
        required: false,
      },
      editable: {
        type: Boolean,
        required: false,
      },
      shown: {
        type: Boolean,
        required: false,
      },
    },

    data() {
      return {
        noteneingabeOverview: {
          anzahl_bewertungen: null,
          minimum: null,
          maximum: null,
          notendurchschnitt: null,
        },
        isBusy: false,
        ladeFehler: false,
        sortBy: '',
        sortDesc: false,
        invalidFields: {},
        notenliste: [],
        pruefungCount: 0,
        pruefungLabel: [],
        fields: [],
      }
    },
    watch: {
      shown(val) {
        if (val && this.notenliste.length == 0) this.getNoten()
      },

      // beim Moduswechsel Tabelle aktualisieren und danach alles neu berechnen
      'noteneingabe.ansichtsmodus.id'() {
        this.updateTable()
        this.$nextTick(this.recomputeAll)
      },

      // wenn Max-Punkte geändert werden, alles neu berechnen
      'noteneingabe.punkte_max'() {
        this.recomputeAll()
      },
    },
    computed: {
      origFields() {
        const basefields = [
          {
            key: 'person.personName',
            sortable: true,
            label: this.$t('global.participants'),
          },
          {
            key: 'korrektur',
            sortable: true,
            class: 'text-center',
            label: this.$t('global.correction'),
          },
          {
            key: 'dispensiert',
            sortable: true,
            class: 'text-center',
            label: this.$t('global.dispensed'),
          },
          {
            key: 'note.notendurchschnitt_prov',
            class: 'text-center',
            sortable: true,
            label: this.$t('global.points') + '-Ø',
          },
          {
            key: 'punkte',
            class: 'text-center',
            sortable: true,
            label: this.$t('global.points'),
          },
        ]

        if (this.noteneingabe.ansichtsmodus?.id === '19919B2666B') {
          // Noten
          basefields.splice(1, 0, {
            key: 'calculatedGrade',
            class: 'text-center',
            sortable: true,
            label: this.$t('global.grade'),
          })
        } else if (this.noteneingabe.ansichtsmodus?.id === '19919B363AA') {
          // Prozent
          basefields.splice(1, 0, {
            key: 'calculatedPercent',
            class: 'text-center',
            sortable: true,
            label: this.$t('global.percent'),
          })
        } else {
          // Punkte
          basefields.splice(1, 0, {
            key: 'note.notendurchschnitt_def',
            class: 'text-center',
            sortable: true,
            label: this.$t('global.points'),
          })
        }

        return basefields
      },

      calcDefClassAverage() {
        if (this.notenliste.length === 0) return

        let notendurchschnittDef = 0
        let count = 0
        this.notenliste.forEach((personDetail) => {
          if (Number(personDetail.note.notendurchschnitt_def)) {
            notendurchschnittDef += Number(
              personDetail.note.notendurchschnitt_def
            )
            count++
          }
        })
        switch (this.noteneingabe.ansichtsmodus?.id) {
          case '19919B2666B':
          case '19919B363AA':
            // Noten / Prozent: notendurchschnitt_def enthält bereits den
            // angezeigten Wert → einfach den Durchschnitt zurückgeben
            return this.formatNotenWert(notendurchschnittDef / count)
          default:
            // Punkte (Rohpunkte)
            return notendurchschnittDef / count
        }
      },
      calcProvClassAverage() {
        if (this.notenliste.length === 0) return

        let notendurchschnittProv = 0
        let count = 0
        this.notenliste.forEach((personDetail) => {
          if (Number(personDetail.note.notendurchschnitt_prov)) {
            notendurchschnittProv += Number(
              personDetail.note.notendurchschnitt_prov
            )
            count++
          }
        })
        return notendurchschnittProv / count
      },
      planned: function () {
        return this.$CONST('PRUEFUNGSTATI').PLANNED
      },
    },
    created() {},
    mounted() {
      if (this.shown && this.notenliste.length == 0) this.getNoten()
    },

    methods: {
      validateForm() {
        let validState = true

        Object.values(this.invalidFields).forEach((val) => {
          if (val == true) validState = false
        })

        return validState
      },

      getNoten() {
        this.isBusy = true

        App.get('noteneingabe/pruefungsnote/', {
          params: {
            id: this.noteneingabe.id,
          },
        })
          .then((response) => {
            this.notenliste = response.data
            let scope = this
            if (this.notenliste[0]) {
              let plannedId = this.planned
              if (this.notenliste[0].details) {
                this.notenliste.forEach(function (benotung) {
                  if (benotung.note.korrektur === 0) {
                    benotung.note.korrektur = null
                  }

                  /*
                  benotung.note.notendurchschnitt_def = scope.formatNotenWert(
                    benotung.note.notendurchschnitt_def
                  )

                  benotung.note.notendurchschnitt_prov = scope.formatNotenWert(
                    benotung.note.notendurchschnitt_prov
                  ) */

                  benotung.details.forEach(function (detail) {
                    if (!detail.pruefung.status) {
                      detail.pruefung.status = {
                        id: plannedId,
                      }
                    }

                    //detail.pruefung.status.id == plannedId ? true : false;
                    detail.pruefung.editable =
                      detail.pruefung.status.id === plannedId

                    /*             detail.bewertung.bewertung = scope.formatNotenWert(
                      detail.bewertung.bewertung
                    ) */
                  })
                })
                this.updateTable()
              }
            }
            this.ladeFehler = false
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e))
            this.ladeFehler = true
          })
          .finally(() => {
            this.isBusy = false
          })
      },

      setDispensiert(index) {
        if (this.notenliste.length === 0) return

        this.notenliste[index].note.dispensiert =
          !this.notenliste[index].note.dispensiert
      },

      async notenSpeichern(switched) {
        if (!this.validateForm()) return

        this.isBusy = true

        let json = Object.assign(this.notenliste)

        if (json.length > 0) {
          json.forEach((personDetail) => {
            if (personDetail.note.notendurchschnitt_def === '-')
              personDetail.note.notendurchschnitt_def = 0
            if (personDetail.note.notendurchschnitt_prov === '-')
              personDetail.note.notendurchschnitt_prov = 0

            personDetail.details.forEach((detail) => {
              if (!isNaN(detail.bewertung.bewertung)) {
                let bewertung = Number(detail.bewertung.bewertung)

                if (bewertung >= 1.0) {
                  detail.bewertung.bewertung = bewertung
                } else {
                  detail.bewertung.bewertung = 0
                }
              }
            })
          })

          App.put('noteneingabe/pruefungsnote/', json, {
            params: { id: this.noteneingabe.id },
          })
            .then((response) => {
              this.notenliste = response.data
              let scope = this
              if (this.notenliste[0]) {
                let plannedId = this.planned
                if (this.notenliste[0].details) {
                  this.notenliste.forEach(function (benotung) {
                    if (benotung.note.korrektur === 0) {
                      benotung.note.korrektur = null
                    }

                    benotung.details.forEach(function (detail) {
                      if (!detail.pruefung.status) {
                        detail.pruefung.status = {
                          id: plannedId,
                        }
                      }

                      //detail.pruefung.status.id == plannedId ? true : false;
                      detail.pruefung.editable =
                        detail.pruefung.status.id === plannedId

                      /*             detail.bewertung.bewertung = scope.formatNotenWert(
                          detail.bewertung.bewertung
                        ) */
                    })
                  })

                  this.updateTable()
                }
              }
              this.ladeFehler = false

              this.$nextTick(this.recomputeAll)

              if (!switched) {
                this.$notify({
                  type: 'success',
                  title: this.$t('global.actionsuccessful'),
                  text: this.$t('global.gradessavedsuccessfully'),
                })
              }
            })
            .catch((e) => {
              this.$notify(apiErrorToAlert(e))
            })
            .finally(() => {
              this.isBusy = false
              if (switched) {
                this.$router.push({
                  name: 'noteneingabe',
                  params: { id: this.noteneingabe.id, anzeige: 0 },
                })
              }
            })
        } else {
          if (switched) {
            this.$router.push({
              name: 'noteneingabe',
              params: { id: this.noteneingabe.id, anzeige: 0 },
            })
          }
        }
      },

      updateTable() {
        if (this.notenliste.length === 0) return

        let count = 1
        this.origFields.splice(5)
        this.fields = this.origFields
        this.pruefungLabel = []

        this.notenliste[0].details.forEach((item) => {
          this.fields.push({
            key: 'pruefung' + count,
            sortable: false,
            class: 'text-center border-left',
            label: this.$t('global.points'),
          })

          this.fields.push({
            key: 'gewichtung' + count,
            sortable: false,
            class: 'text-center',
            label: 'Gew.',
          })

          if (item.pruefung && item.pruefung.bezeichnung)
            this.pruefungLabel.push(item.pruefung.bezeichnung)

          count++
        })

        this.pruefungCount = count - 1
        this.isBusy = false
        this.$nextTick(this.recomputeAll)
      },

      checkBewertung(pNo, index) {
        if (this.notenliste.length === 0) return

        if (this.notenliste[index].details[pNo - 1]) {
          let val = this.notenliste[index].details[pNo - 1].bewertung.bewertung
          this.calcPunkteschnittProv(this.notenliste[index])

          if (isNaN(val) || Number(val) < 0) {
            this.notenliste[index].details[pNo - 1].invalid = false
            this.invalidFields['pruefung' + pNo + index] = true
          } else {
            this.notenliste[index].details[pNo - 1].invalid = true
            this.invalidFields['pruefung' + pNo + index] = null
          }
        }
        this.setNoteneingabeOverview()
      },

      setNoteneingabeOverview() {
        if (this.notenliste.length === 0) return

        let notenCount = 0
        let noteMax = 0
        let noteMinimum = Infinity
        this.notenliste.forEach((personDetail) => {
          personDetail.details.forEach((detail) => {
            if (Number(detail.bewertung.bewertung)) {
              notenCount++
              if (detail.bewertung.bewertung > noteMax)
                noteMax = detail.bewertung.bewertung
              if (detail.bewertung.bewertung < noteMinimum)
                noteMinimum = detail.bewertung.bewertung
            }
          })
        })

        this.noteneingabeOverview.maximum = noteMax
        this.noteneingabeOverview.minimum =
          noteMinimum === Infinity ? 0 : noteMinimum
        this.noteneingabeOverview.anzahl_bewertungen = notenCount
        this.noteneingabeOverview.notendurchschnitt = Number(
          this.calcDefClassAverage
        )
          ? Number(this.calcDefClassAverage)
          : 0

        this.$emit('overviewChanged', this.noteneingabeOverview)
      },
      checkKorrektur(index) {
        if (this.notenliste.length === 0) return
        let val = this.notenliste[index].note.korrektur

        if (val === null || val === undefined || val === '') {
          this.notenliste[index].note.invalid = null
          this.invalidFields['note' + index] = null
          this.calcPunkteschnittProv(this.notenliste[index])
          return
        }

        val = parseFloat(val)
        this.calcPunkteschnittProv(this.notenliste[index])

        if (isNaN(val) || Number(val) < 0) {
          this.notenliste[index].note.invalid = false
          this.invalidFields['note' + index] = true
        } else {
          this.notenliste[index].note.invalid = true
          this.invalidFields['note' + index] = null
        }

        this.calculatePunkteschnittDef(this.notenliste[index])
      },

      calcExamAverage(examIndex) {
        if (this.notenliste.length === 0) return
        let examDurchschnitt = 0
        let count = 0
        this.notenliste.forEach((personDetail) => {
          if (Number(personDetail.details[examIndex].bewertung.bewertung)) {
            examDurchschnitt += Number(
              personDetail.details[examIndex].bewertung.bewertung
            )
            count++
          }
        })
        return examDurchschnitt / count
      },

      calculateGradeWithFormula(bewertung) {
        if (this.noteneingabe.formel) {
          const expression = this.noteneingabe.formel
            .replace(/MP/g, this.noteneingabe.punkte_max)
            .replace(/EP/g, bewertung)

          try {
            return this.formatNotenWert(eval(expression))
          } catch (e) {
            return 0
          }
        } else {
          return 0
        }
      },

      calcPunkteschnittProv(personDetail) {
        if (this.notenliste.length === 0) return

        let notendurchschnittProv = 0
        let count = 0
        personDetail.details.forEach((detail) => {
          if (Number(detail.bewertung.bewertung)) {
            notendurchschnittProv += Number(detail.bewertung.bewertung)
            count++
          }
        })
        let weightedSum = 0
        let totalWeight = 0
        personDetail.details.forEach((detail) => {
          const score = Number(detail.bewertung.bewertung)
          // Use the weighting from the exam, defaulting to 1 if not provided
          const weight =
            detail.pruefung && detail.pruefung.gewichtung
              ? Number(detail.pruefung.gewichtung)
              : 1
          if (!isNaN(score)) {
            weightedSum += score * weight
            totalWeight += weight
          }
        })
        personDetail.note.notendurchschnitt_prov = this.formatNotenWert(
          totalWeight > 0 ? weightedSum / totalWeight : 0
        )

        this.calculatePunkteschnittDef(personDetail)
      },

      calculatePunkteschnittDef(personDetail) {
        // Basispunkte bestimmen (Rohpunkte, ggf. aus Korrektur)
        const k = personDetail.note.korrektur
        const hasKorrektur = k !== null && k !== '' && !isNaN(parseFloat(k))

        let basePoints
        if (hasKorrektur) {
          const pointsFromCorrection = this.korrekturToPoints(k)
          basePoints =
            pointsFromCorrection !== null
              ? this.formatNotenWert(pointsFromCorrection)
              : personDetail.note.notendurchschnitt_prov
        } else {
          basePoints = personDetail.note.notendurchschnitt_prov
        }

        // Abgeleitete Anzeigewerte berechnen (immer auf Basis der Rohpunkte)
        personDetail.calculatedGrade = this.calculateGradeWithFormula(basePoints)
        personDetail.calculatedPercent =
          this.noteneingabe.punkte_max > 0
            ? this.formatNotenWert(
                (Number(basePoints) / this.noteneingabe.punkte_max) * 100
              )
            : 0

        // notendurchschnitt_def = Wert der 2. Spalte (je nach Anzeigemodus)
        const mode = this.noteneingabe.ansichtsmodus?.id
        if (mode === '19919B363AA') {
          // Prozent
          personDetail.note.notendurchschnitt_def = personDetail.calculatedPercent
        } else if (mode === '19919B2666B') {
          // Noten
          personDetail.note.notendurchschnitt_def = personDetail.calculatedGrade
        } else {
          // Punkte (Rohpunkte)
          personDetail.note.notendurchschnitt_def = basePoints
        }
      },
      formatNotenWert(value) {
        return value === undefined || value === null || value === '' || isNaN(value)
          ? null
          : parseFloat(value).toFixed(1)
      },

      formatNote(pNo, index) {
        if (this.notenliste.length === 0) return

        this.notenliste[index].details[pNo - 1].bewertung.bewertung =
          this.formatNotenWert(
            this.notenliste[index].details[pNo - 1].bewertung.bewertung
          )
      },

      korrekturToPoints(value) {
        // Convert correction input into points based on current view mode
        if (value === null || value === undefined || value === '') return null
        const num = parseFloat(value)
        if (isNaN(num)) return null

        const maxPoints = Number(this.noteneingabe.punkte_max || 0)
        const mode = this.noteneingabe.ansichtsmodus?.id
        const clamp = (x, min, max) => Math.min(Math.max(x, min), max)

        switch (mode) {
          case '19919B363AA': // Prozent
            if (maxPoints <= 0) return null
            return clamp((num / 100) * maxPoints, 0, maxPoints)

          case '19919B2666B': {
            // Noten
            // Invertiere die Notenformel per Binärsuche (0..maxPoints)
            let lo = 0,
              hi = maxPoints > 0 ? maxPoints : 0
            if (hi === 0) return null
            for (let i = 0; i < 30; i++) {
              const mid = (lo + hi) / 2
              const g = parseFloat(this.calculateGradeWithFormula(mid))
              if (isNaN(g)) return null
              if (g < num) lo = mid
              else hi = mid
            }
            return clamp((lo + hi) / 2, 0, maxPoints)
          }

          default: // Punkte
            return clamp(num, 0, maxPoints || Number.POSITIVE_INFINITY)
        }
      },

      recomputeAll() {
        if (!Array.isArray(this.notenliste) || this.notenliste.length === 0)
          return
        // *_prov neu aufbauen und danach *_def inkl. Korrektur setzen
        this.notenliste.forEach((p) => this.calcPunkteschnittProv(p))
        // Overview/Footers aktualisieren
        this.setNoteneingabeOverview()
      },
    },
  }
</script>
